export default __webpack_public_path__ + "static/media/404-page.d29b88de.png";